export const DEFAULT_COUNTRY = process.env.REACT_APP_REGION === 'CN' ? 'CHN' : 'USA';
export const DEFAULT_CURRENCY = process.env.REACT_APP_REGION === 'CN' ? 'CNY' : 'USD';
export const DEFAULT_LANGUAGE = process.env.REACT_APP_REGION === 'CN' ? 'Chinese' : 'English';
